export default __webpack_public_path__ + "static/media/ebola.bcfe53e3.png";